// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__25RUk","footer":"Form_footer__-ndD0"};